<template>
  <section v-if="giftCardOrderItems.length">
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-min no-br">{{ "index" | translate }}</th>
          <th>{{ "vendor" | translate }}</th>
          <th>{{ "currency" | translate }}</th>
          <th>{{ "gift_card" | translate }}</th>
          <th>{{ "payments" | translate }}</th>
          <th>{{ "comment" | translate }}</th>
          <th v-no-print v-if="!readonly">@</th>
        </tr>
      </thead>

      <tr v-for="(item, index) in giftCardOrderItems" :key="'item' + index">
        <td>{{ index + 1 }}</td>
        <td class="w-10">{{ item.vendor }}</td>
        <td class="w-10">{{ item.currency }}</td>
        <td>
          <part-transaction-list-present
            :transactions="item.giftCards"
          ></part-transaction-list-present>
        </td>
        <td>
          <part-transaction-list-present
            :transactions="item.payments"
          ></part-transaction-list-present>
        </td>
        <td class="w-15">{{ item.comment }}</td>
        <td class="w-min no-br" v-no-print v-if="!readonly">
          <a
            class="mr-1"
            href="javascript:void(0)"
            @click="editPurchaseOrderItem(item)"
            >{{ "edit" | translate }}</a
          >
          <a href="javascript:void(0)" @click="remove(index)">{{
            "remove" | translate
          }}</a>
        </td>
      </tr>

      <tfoot>
        <tr>
          <th colspan="3">{{ "total" | translate }}</th>
          <th>
            <div v-for="(t, index) in totalGiftCardAmount" :key="`t` + index">
              {{ t.total | number(2) }} {{ t.currency | translate }}
            </div>
          </th>
          <th colspan="2" class="text-right">
            <div v-for="(t, index) in totalPaymentAmount" :key="`t` + index">
              {{ t.total | number(2) }} {{ t.currency | translate }}
            </div>
          </th>
          <th v-no-print v-if="!readonly"></th>
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
import { ModalService } from "@/modules/xs-modal";
import ModalGiftCardOrderItemForm from "./ModalGiftCardOrderItemForm";
import PartTransactionListPresent from "./PartTransactionListPresent";
import _ from "lodash";

export default {
  props: ["giftCardOrderItems", "readonly"],
  computed: {
    totalGiftCardAmount() {
      let currencyList = [
        ...new Set(this.giftCardOrderItems.map(item => item.currency))
      ];

      return currencyList.map(curr => {
        return {
          currency: curr,
          total: this.giftCardOrderItems.reduce((sum, item) => {
            return (
              sum +
              item.giftCards.reduce((gcSum, gc) => {
                if (gc.currency === curr && gc.amount) {
                  return gcSum + gc.amount;
                }
                return gcSum;
              }, 0)
            );
          }, 0)
        };
      });
    },
    totalPaymentAmount() {
      let currencyList = [
        ...new Set(this.giftCardOrderItems.map(item => item.currency))
      ];

      return currencyList.map(curr => {
        return {
          currency: curr,
          total: this.giftCardOrderItems.reduce((sum, item) => {
            return (
              sum +
              item.payments.reduce((gcSum, gc) => {
                if (gc.currency === curr && gc.amount) {
                  return gcSum + gc.amount;
                }
                return gcSum;
              }, 0)
            );
          }, 0)
        };
      });
    }
  },
  data() {
    return {};
  },
  methods: {
    editPurchaseOrderItem(item) {
      ModalService.open(ModalGiftCardOrderItemForm, {
        editingItem: item
      }).then(purchaseOrderItem => {
        _.assign(item, purchaseOrderItem);
        this.$emit("update");
      });
    },
    remove(index) {
      this.giftCardOrderItems.splice(index, 1);
      this.$emit("update");
    }
  },
  components: {
    PartTransactionListPresent
  }
};
</script>
